<div class="card-container">
  <div class="title-wrapper">
    <h3>Select your music</h3>
  </div>
  <div class="subtitle-wrapper">
    <h5>Choose your music for the room</h5>
  </div>
  <div class="playlist-options-div">
    @if (showLoader) {
      <div class="loading-container"><app-loading></app-loading></div>
    }
    <div class="internal-div">
      @for (playlist of playlistOptions; track playlist.playlistId) {
        <div
          class="playlist-option"
          [ngClass]="{ selected: playlistSelectedId === playlist.playlistId }"
          (click)="selectPlaylist(playlist.playlistId)"
        >
          <div class="playlist-name">
            @if (!playlistNone(playlist.playlistId)) {
              <button
                (click)="playExampleTrack(playlist.playlistId)"
                class="play_btn"
                [ngClass]="{ stop_circle: isPlaying(playlist.playlistId) }"
              >
                @if (isPlaying(playlist.playlistId)) {
                  <mat-progress-spinner mode="indeterminate" class="custom-circle-infinite-loader">
                  </mat-progress-spinner>
                  <div class="stop-icon"><mat-icon>stop</mat-icon></div>
                } @else {
                  <mat-icon svgIcon="PLAY_MUSIC"></mat-icon>
                }
              </button>
            } @else {
              <mat-icon class="music_off" svgIcon="MUSIC_OFF"></mat-icon>
            }

            {{ playlist.name }}
          </div>
          <div>
            {{ playlist.qty ? playlist.qty + ' songs' : 'No songs' }}
          </div>
        </div>
      }
    </div>
  </div>
  <div class="footer-wrapper">
    @if (hasBackStepButton) {
      <button data-testid="secondaryButton" class="secondary-button" (click)="backStep()">Back</button>
    }
    <button data-testid="primaryButton" [disabled]="disableApplyButton()" class="primary-button" (click)="nextStep()">
      {{ isCreateFlow ? 'Next' : 'Apply' }}
    </button>
  </div>
</div>
